import LookUpModel from "stores/lookup/models/LookUpModel";

export default class NazioniModel extends LookUpModel {
  constructor(data: Partial<NazioniModel>) {
    super(data);

    this.update(data);
  }
}
